// =========================
// NotAdviceDisclaimer — PLATFORM-002 (WS2) reusable ADR-044 clarifier
//
// ONE canonical "decision-support, not advice" disclaimer for every Opportunity
// Intelligence surface, so the wording stays consistent and is defined once.
// Reuse this on any surface that presents a signal, score, recommendation,
// forecast, or qualification output.
//
// ADR-044 / ADR-053 (signal-not-advice): outputs are decision-support signals;
// the investor makes the final decision. Design-system tokens only (no hex).
// =========================

import React from 'react';

// Canonical wording (matches the analyzer surface doctrine). Exported so
// non-visual guards / other components can reference the single source string.
export const NOT_ADVICE_TEXT =
  'Decision-support signal — you make the final decision. Not investment advice.';

export default function NotAdviceDisclaimer({ style = {}, testId = 'not-advice-disclaimer' }) {
  return (
    <p
      data-testid={testId}
      style={{
        margin: 0,
        fontSize: 'var(--text-xs)',
        color: 'var(--color-steel)',
        ...style,
      }}
    >
      {NOT_ADVICE_TEXT}
    </p>
  );
}
